module.exports = __webpack_public_path__ + "img/電気回路_3_7_5.7cf84493.png";